import React from 'react';
import "./../assets/css/navbar.css";
import { FaLocationArrow } from "react-icons/fa";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow">
      <div className="container">
        <a className="navbar-brand" href="/">
          <span className="nj">N.J</span> <span className="achat">Achat</span>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link custom-link" href="/colis">Suivre votre colis <FaLocationArrow/></a>
            </li>        
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
